/* @flow */
import React from 'react';
import Image from 'components/Image.jsx';
import Button from 'components/Button.jsx';
import GoogleAPI from 'lib/GoogleAPI';
import AuthActions from 'auth/AuthActions';
import ToastActions from 'actions/ToastActions';

import './styles/GoogleSignIn.scss';

class GoogleSignIn extends React.Component {
  static propTypes = {
    body: React.PropTypes.string,
    onSuccess: React.PropTypes.func,
  };

  static defaultProps = {
    body: 'Log in with Google',
  };

  componentDidMount() {
    // Loads the Google API and initializes an auth instance so that the sign in flow becomes
    // synchronous. If the sign in button is clicked before the API is loaded, the Google sign
    // in popup will likely get blocked by a popup blocker.
    GoogleAPI.initWithAuthInstance();
  }

  handleAuthorizationCode = (code: string) => {
    AuthActions
      .googleSignIn(code)
      .then(this.props.onSuccess || (() => {}))
      .catch(this.handleAuthorizationError);
  };

  handleAuthorizationError = () => {
    ToastActions.showErrorToast(
      'There was an error logging in with Google. Please try again later.'
    );
  };

  handleClick = () => {
    GoogleAPI.fetchAuthorizationCode()
      .then(this.handleAuthorizationCode)
      .catch(this.handleAuthorizationError);
  };

  render() {
    return (
      <Button
        className="GoogleSignIn"
        type="button"
        level="secondary"
        color="thunder"
        full
        onClick={this.handleClick}
        eventElementName="GoogleSignIn">
        <Image src={require('assets/images/superg.svg')} />
        {this.props.body}
      </Button>
    );
  }
}

export default GoogleSignIn;



// WEBPACK FOOTER //
// ./src/auth/components/GoogleSignIn.jsx